import { matchPath, useLocation } from "react-router-dom";
import { DashboardRoutes } from "@/router/constant";
import refundRoutes from "@/refund/routes/constants";

export function useSelectedTab(): string {
  const location = useLocation();
  // routes should be inserted by correct order in here so that the first found route is the correct one
  const ROUTES = {
    // Sale
    report: DashboardRoutes.mySale.report.url,
    balanceAndWithdraw: DashboardRoutes.mySale.balanceAndWithdraw.url,
    refund: refundRoutes.root.url,

    // Shop
    product: DashboardRoutes.myShop.product.list.url,
    invoice: DashboardRoutes.myShop.invoice.list.url,
    customer: DashboardRoutes.myShop.customer.list.url,
    coupon: DashboardRoutes.myShop.coupon.list.url,
    bnplActivation: DashboardRoutes.myShop.bnpl.activation.root.url,
    bnplList: DashboardRoutes.myShop.bnpl.list.root.url,
    bnplManage: DashboardRoutes.myShop.bnpl.manage.root.url,
    bnplCalendar: DashboardRoutes.myShop.bnpl.financialCalender.root.url,
    bnplPlans: DashboardRoutes.myShop.bnpl.plans.root.url,
    bnpl: DashboardRoutes.myShop.bnpl.root.url,

    // Connections
    plugin: DashboardRoutes.connections.plugins.root.url,
    developer: DashboardRoutes.connections.developers.root.url,
    oauth: DashboardRoutes.connections.oauth.root.url,

    // Digital Account
    yourAccount: DashboardRoutes.digitalAccount.yourAccount.url,
    turnOver: DashboardRoutes.digitalAccount.saman.turnOver.url,
    request: DashboardRoutes.digitalAccount.saman.request.url,

    // Settlement
    settlementOverview: DashboardRoutes.settlement.overview.url,
    settlementReport: DashboardRoutes.settlement.report.list.url,
    settlementTransaction: DashboardRoutes.settlement.transaction.url,
    settlementId: DashboardRoutes.settlement.id.url,
  };

  const matchedRoute = Object.values(ROUTES).find((path) => {
    const matchedPath = matchPath({ path, end: false }, location.pathname);
    return Boolean(matchedPath);
  });

  const selectedPath = matchedRoute || location.pathname;
  return selectedPath;
}
